import { apiClient } from "../apiClient";

export const LOP_TIN_CHI_ENDPOINT = "lop-tin-chi";

export const xepTkbChuanBiApi = {
    // Tạo lại lớp tín chỉ + sự kiện theo danh sách kế hoạch môn được chọn
    TaoLaiTheoMon: (request: { id_kh_mons: number[], ky_dang_ky: number }) =>
        apiClient.post(`${LOP_TIN_CHI_ENDPOINT}/tao-lai-loptc-theo-mon`, request),
    // Cập nhật sự kiện: chỉ sinh cho KHM CHƯA có sự kiện. KHÔNG xóa dữ liệu cũ.
    CapNhatSuKienTheoMon: (request: { id_kh_mons: number[], ky_dang_ky: number }) =>
        apiClient.post(`${LOP_TIN_CHI_ENDPOINT}/cap-nhat-su-kien-theo-mon`, request),
};
